import { QueryClient } from "@tanstack/query-core";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import React from "react";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: false,
    },
  },
});
const TanstackQueryProvider = (props: any) => {
  const { children } = props;

  const persister = createSyncStoragePersister({
    storage: typeof window !== "undefined" ? window.localStorage : undefined,
  });
  return (
    <PersistQueryClientProvider
      persistOptions={{
        persister,
        dehydrateOptions: {
          shouldDehydrateQuery: (query) => query.queryKey.includes("persist"),
        },
      }}
      client={queryClient}
    >
      {children}
    </PersistQueryClientProvider>
  );
};
export default TanstackQueryProvider;
